export const typeValues = ['primary', 'secondary', 'tertiary'];